import log from 'salvo-lite/log'

class ContactForm {
    constructor (theme, elem) {
        this._elem = elem
        this._labels = {
            'two': elem.querySelector('[for="ContactFormAgree2"]'),
            'three': elem.querySelector('[for="ContactFormAgree3"]')
        }
        this._submitBtn = elem.querySelector('[type="submit"]')
        this._form = elem.querySelector('#ContactForm')
        this._warning = elem.querySelector('.form-warning')
    }

    onInit () {
        log.debug(this.constructor.name, 'Initializing', this)
        this._oncClick()
    }

    _oncClick () {
        let two = this._labels.two
        let three = this._labels.three

        two.addEventListener('click', e => {
            e.preventDefault()
            this._checkDis(two, three)
        })

        three.addEventListener('click', e => {
            e.preventDefault()
            this._checkDis(three, two)
        })

        this._submitBtn.addEventListener('click', e => {
            e.preventDefault()
            this._onSubmit()
        })
    }

    _checkDis (dis, dat) {
        let disInput = dis.querySelector('input')
        let datInput = dat.querySelector('input')

        disInput.checked = !disInput.checked

        if (disInput.checked && datInput.checked) { datInput.checked = false }

        if (!this._warning.classList.contains('hide')) { this._warning.classList.add('hide') }
    }

    _onSubmit () {
        let twoInput = this._labels.two.querySelector('input')
        let threeInput = this._labels.three.querySelector('input')

        if (twoInput.checked || threeInput.checked) {
            this._form.submit()
        } else {
            this._warning.classList.remove('hide')
        }
    }
}

export default ContactForm



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ContactForm.js